import { axiosSerializerobjectToQueryParams, ListOutput } from '@allocab/allocab-commons-shared-types';
import { DedicatedPackageOutput, FindDedicatedPackageByAccountInput } from '@allocab/allocab-dedicated-driver-types';
import { useInfiniteQuery, useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { DEFAULT_CACHE_TIME, queryClient } from '../services/datastore/react-query';
import { InfiniteQueryOptions } from '../services/datastore/types';
import { driverApi } from '../services/network/Api';

export const PACKAGES_LIMIT = 10;

export type Input = Omit<FindDedicatedPackageByAccountInput, 'offset' | 'limit'> & { limit?: number };

export const fetchTripPackages = (input: FindDedicatedPackageByAccountInput) =>
  driverApi.get<FindDedicatedPackageByAccountInput, DedicatedPackageOutput, 'list'>(
    `/v1/dedicated-package/account/user`,
    input,
    {
      paramsSerializer: axiosSerializerobjectToQueryParams,
    },
  );
export const useFetchTripPackages = (input: Input, pageNumber = 1) => {
  const limit = input.limit ?? PACKAGES_LIMIT;
  const apiInput: FindDedicatedPackageByAccountInput = { ...input, limit, offset: (pageNumber - 1) * limit };

  return useQuery(queryKeys.user.fetchTripPackages(apiInput), () => fetchTripPackages(apiInput), {
    keepPreviousData: true,
  });
};

export const prefetchTripPackagesPage = (input: Input, pageNumber = 1) => {
  const limit = input.limit ?? PACKAGES_LIMIT;
  const apiInput: FindDedicatedPackageByAccountInput = { ...input, limit, offset: (pageNumber - 1) * limit };

  queryClient.prefetchQuery(queryKeys.user.fetchTripPackages(apiInput), () => fetchTripPackages(apiInput), {
    staleTime: DEFAULT_CACHE_TIME,
  });
};

export const useInfiniteFetchTripPackages = (
  input: Input,
  options: InfiniteQueryOptions<
    typeof queryKeys.user.fetchInfiniteTripPackages,
    ListOutput<DedicatedPackageOutput>
  > = {},
) => {
  const fetchTripsQuery = useInfiniteQuery(
    queryKeys.user.fetchInfiniteTripPackages(input),
    ({ pageParam = 0 }: { pageParam?: number }) =>
      fetchTripPackages({ limit: PACKAGES_LIMIT, offset: pageParam, ...input }),
    {
      getNextPageParam: (lastPage, allPages) =>
        lastPage.nbItems < PACKAGES_LIMIT ? undefined : PACKAGES_LIMIT * allPages.length,
      ...options,
    },
  );

  return fetchTripsQuery;
};
